import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const MailUnread: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.65625"
      y="3.20312"
      width="12.6875"
      height="9.59375"
      rx="0.90625"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M1.9375 3.79688L7.35547 7.9375C7.7375 8.23368 8.2625 8.23368 8.64453 7.9375L14.0625 3.79688"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
